var exports = {
  "Q": "RiverAccordionWrapper__-xwbJ_",
  "v": "RiverAccordion__XIT8iu",
};

module.exports = exports;
